import { FC, MutableRefObject, useEffect, useRef } from 'react';
import { DireccionResumen } from './DireccionResumen';
import { ProductoResumen } from './ProductoResumen';
import { SmilesResumen } from './SmilesResumen';
import { CorreoResumen } from './CorreoResumen';
import { TelefonoResumen } from './TelefonoResumen';
import { ProductoData } from '../../model/ProductoData';
import { Domicilio } from '../../model/Domicilio';
import { SmilesForm } from './useSmiles';
import { Phone } from '../../model/Phone';
import { ProductConfig } from './ProductConfig';
import { OutlineVStack } from '../shared/OutlineVStack';

type Props = {
  product: ProductoData;
  productConfig: ProductConfig | undefined;
  getPhone: () => Phone | undefined;
  getAddress: () => Domicilio | undefined;
  getSmilesData: () => SmilesForm | undefined;
};

export const ResumenContainer: FC<Props> = ({ product, productConfig, getPhone, getAddress, getSmilesData: getClientData }) => {
  const ref: MutableRefObject<HTMLDivElement | null> = useRef(null);
  const isPhysicalProduct = product.esFisico();

  /** Accesibilidad: se hace foco en este componente
   * cuando es cargado por primera vez.
   */
  useEffect(() => {
    ref?.current?.focus();
  }, []);

  return (
    <OutlineVStack tabIndex={0} ref={ref} outline="none">
      <ProductoResumen product={product} productConfig={productConfig} />
      <DireccionResumen getAddress={getAddress} />
      <SmilesResumen getClientData={getClientData} />
      <CorreoResumen show={!isPhysicalProduct} />
      <TelefonoResumen getPhone={getPhone} />
    </OutlineVStack>
  );
};
